import { formatMoney } from '../../utils/stringUtils';
import requestService from '../../services/request';
import {
  CONFIG,
  FEATURE_TOGGLES,
  FINANCIAL_POSITION,
  ROLES,
  UNIT,
  USER,
} from '../../utils/constants';
export default {
  state: {
    selectedContract: undefined,
    financialPositionError: false,
    financialPositionLoading: false,
    loadingPaid: false,
    loadingLate: false,
    loadingToExpire: false,
    loadingTotals: false,
    financialPositionData: {
      late: [],
      toExpire: [],
      paid: [],
      paidTotal: null,
      toExpireTotal: null,
      lateTotal: null,
      hasPayableLatePaymentSlips: false,
      baseDate: null,
    },
    financialSummaryItems: {
      lateTotal: null,
      paidTotal: null,
      toExpireTotal: null,
    },
    unitFinancialPositions: {
      // [contractId]: {
      //  "contractStatus": "Ativo",
      //  "contractType": "Avulso",
      //  "isMain": false,
      //   late: [],
      //   toExpire: [],
      //   paid: [],
      //   paidTotal: null,
      //   toExpireTotal: null,
      //   lateTotal: null,
      //   hasPayableLatePaymentSlips: false,
      //   baseDate: null,
      // },
    },
  },
  getters: {
    [FINANCIAL_POSITION.GET_UNIT_POSITIONS]: (state) =>
      state.unitFinancialPositions,
    [FINANCIAL_POSITION.GET_DATA]: (state) => state.financialPositionData,
    [FINANCIAL_POSITION.GET_SUMMARY]: (state) => state.financialSummaryItems,

    [FINANCIAL_POSITION.LOADING]: (state) => state.financialPositionLoading,
    [FINANCIAL_POSITION.LOADING_LATE]: (state) => state.loadingLate,
    [FINANCIAL_POSITION.LOADING_PAID]: (state) => state.loadingPaid,
    [FINANCIAL_POSITION.LOADING_TO_EXPIRE]: (state) => state.loadingToExpire,
    [FINANCIAL_POSITION.LOADING_TOTALS]: (state) => state.loadingTotals,
    [FINANCIAL_POSITION.ERROR]: (state) => state.financialPositionError,
  },
  mutations: {
    [FINANCIAL_POSITION.SET_UNIT_POSITIONS]: (state, payload) =>
      (state.unitFinancialPositions = payload),
    [FINANCIAL_POSITION.SET_DATA]: (state, mainPositionData) => {
      state.financialPositionData = mainPositionData;

      state.financialSummaryItems = {
        lateTotal: formatMoney(mainPositionData.lateTotal),
        paidTotal: formatMoney(mainPositionData.paidTotal),
        toExpireTotal: formatMoney(mainPositionData.toExpireTotal),
      };
    },
  },
  actions: {
    [FINANCIAL_POSITION.FETCH_POSITION]: async (
      { state, getters, commit, dispatch },
      { contract, getSlipsUrl = true }
    ) => {
      if (getters[FEATURE_TOGGLES.UNIT_FINANCIAL_POSITION]) {
        return await dispatch(FINANCIAL_POSITION.FETCH_BY_UNIT, {
          contract,
          getSlipsUrl,
        });
      } else {
        return await dispatch(FINANCIAL_POSITION.FETCH_BY_CONTRACT, {
          contract,
          getSlipsUrl,
        });
      }
    },

    [FINANCIAL_POSITION.FETCH_BY_UNIT]: async (
      { state, getters, commit, dispatch },
      { contract, getSlipsUrl }
    ) => {
      if (getters[USER.GET_USER_ROLE] !== ROLES.CLIENT_ROLE) return;
      if (state.unitFinancialPositions[contract.id]) {
        commit(
          FINANCIAL_POSITION.SET_DATA,
          state.unitFinancialPositions[contract.id]
        );
        return state.unitFinancialPositions[contract.id];
      }
      if (state.financialPositionLoading) return;
      try {
        state.loadingPaid = true;
        state.loadingLate = true;
        state.loadingToExpire = true;
        state.financialPositionLoading = true;
        state.financialPositionError = false;

        let selectedUnit = getters[UNIT.GET_SELECTED];
        const params = {
          // contractId: contract.id,
          contractType: contract.type,
          productCode: selectedUnit.product.code,
          blockCode: selectedUnit.block.code,
          unitCode: selectedUnit.unit.code,
          getSlipsUrl: getSlipsUrl ? 1 : 0,
        };

        let unitPositions = await requestService(
          process.env.FINANCIAL_API_URL + `/unit/${selectedUnit.unit.id}`,
          'GET',
          {
            params: { ...params },
            localErrorHandling: true,
            retries: 0,
          }
        );
        const unitDict = unitPositions.reduce(
          (acc, { contractId, ...rest }) => {
            acc[contractId] = rest;
            return acc;
          },
          {}
        );

        commit(FINANCIAL_POSITION.SET_UNIT_POSITIONS, unitDict);
        commit(
          FINANCIAL_POSITION.SET_DATA,
          state.unitFinancialPositions[contract.id]
        );

        return state.financialPositionData;
      } catch (err) {
        state.financialPositionError = true;
      } finally {
        state.loadingPaid = false;
        state.loadingLate = false;
        state.loadingToExpire = false;
        state.financialPositionLoading = false;
      }
    },

    [FINANCIAL_POSITION.FETCH_BY_CONTRACT]: async (
      { state, getters, commit, dispatch },
      { contract, getSlipsUrl }
    ) => {
      if (getters[USER.GET_USER_ROLE] !== ROLES.CLIENT_ROLE) return;
      // if (getters[UNIT.GET_USER_ROLE]?.id === contract.id) return;
      try {
        state.financialPositionLoading = true;
        state.financialPositionError = false;
        let contractPosition = {
          late: [],
          toExpire: [],
          paid: [],
          paidTotal: null,
          toExpireTotal: null,
          lateTotal: null,
          hasPayableLatePaymentSlips: false,
          baseDate: null,
        };
        let selectedUnit = getters[UNIT.GET_SELECTED];

        state.selectedContract = contract;
        state.loadingTotals = true;
        state.loadingPaid = true;
        state.loadingLate = true;
        state.loadingToExpire = true;
        const params = {
          contractId: contract.id,
          contractType: contract.type,
          productCode: selectedUnit.product.code,
          blockCode: selectedUnit.block.code,
          unitCode: selectedUnit.unit.code,
          getSlipsUrl: getSlipsUrl ? 1 : 0,
        };
        const promises = [];

        promises.push(
          requestService(process.env.FINANCIAL_API_URL, 'GET', {
            params: { ...params, types: ['toExpire'] },
            localErrorHandling: true,
            retries: 0,
          }).then((res) => {
            if (res.contractId === state.selectedContract.id.toString()) {
              contractPosition = {
                ...contractPosition,
                ...res,
              };
              state.loadingToExpire = false;
              return res;
            }
          })
        );

        promises.push(
          requestService(process.env.FINANCIAL_API_URL, 'GET', {
            params: { ...params, types: ['late'] },
            localErrorHandling: true,
            retries: 0,
          }).then((res) => {
            if (res.contractId === state.selectedContract.id.toString()) {
              contractPosition = {
                ...contractPosition,
                ...res,
              };
              state.loadingLate = false;
              return res;
            }
          })
        );

        promises.push(
          requestService(process.env.FINANCIAL_API_URL, 'GET', {
            params: { ...params, types: ['paid'] },
            localErrorHandling: true,
            retries: 0,
          }).then((res) => {
            if (res.contractId === state.selectedContract.id.toString()) {
              contractPosition = {
                ...contractPosition,
                ...res,
              };
              state.loadingPaid = false;
              return res;
            }
          })
        );

        await Promise.all(promises);

        commit(FINANCIAL_POSITION.SET_DATA, contractPosition);

        return contractPosition;
      } catch (err) {
        state.financialPositionError = true;
      } finally {
        state.loadingTotals = false;
        state.financialPositionLoading = false;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/financial.js